/**
 * REFLUX GOURMET — Theme JavaScript
 * Mobile menu, AJAX cart, parallax, scroll animations
 */

(function () {
  'use strict';

  /* ========== MOBILE MENU ========== */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavClose = document.querySelector('.mobile-nav__close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  // Close on link click
  document.querySelectorAll('.mobile-nav a').forEach(function (link) {
    link.addEventListener('click', closeMobileNav);
  });

  /* ========== CART DRAWER ========== */
  const cartDrawer = document.getElementById('cart-drawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
        updateUpsellVisibility(cart);
      })
      .catch(function (err) { console.error('Cart fetch error:', err); });
  }

  function updateUpsellVisibility(cart) {
    var upsellEl = document.getElementById('cart-drawer-upsell');
    if (!upsellEl) return;

    var hideEmpty = upsellEl.getAttribute('data-hide-empty') === 'true';
    var showTriggerIdsAttr = upsellEl.getAttribute('data-show-trigger-ids') || '';
    var hideTriggerIdsAttr = upsellEl.getAttribute('data-hide-trigger-ids') || '';
    var showTriggerIds = showTriggerIdsAttr ? showTriggerIdsAttr.split(',') : [];
    var hideTriggerIds = hideTriggerIdsAttr ? hideTriggerIdsAttr.split(',') : [];

    var cartProductIds = cart.items.map(function (item) {
      return String(item.product_id);
    });

    var upsellItems = upsellEl.querySelectorAll('[data-product-id]');
    var anyVisible = false;
    upsellItems.forEach(function (item) {
      var itemId = item.getAttribute('data-product-id');
      var inCart = itemId && cartProductIds.indexOf(itemId) !== -1;
      if (inCart) {
        item.style.display = 'none';
      } else {
        item.style.display = '';
        anyVisible = true;
      }
    });

    var show = true;
    if (hideEmpty && cart.item_count === 0) show = false;

    if (showTriggerIds.length > 0) {
      var showTriggerInCart = showTriggerIds.some(function (id) {
        return cartProductIds.indexOf(id) !== -1;
      });
      if (!showTriggerInCart) show = false;
    }

    if (hideTriggerIds.length > 0) {
      var hideTriggerInCart = hideTriggerIds.some(function (id) {
        return cartProductIds.indexOf(id) !== -1;
      });
      if (hideTriggerInCart) show = false;
    }

    if (!anyVisible) show = false;

    if (show) {
      upsellEl.removeAttribute('hidden');
    } else {
      upsellEl.setAttribute('hidden', '');
    }
  }

  function renderCartDrawer(cart) {
    var itemsContainer = document.getElementById('cart-drawer-items');
    var footerContainer = document.getElementById('cart-drawer-footer');
    if (!itemsContainer || !footerContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p></div>';
      footerContainer.innerHTML = '';
      return;
    }

    var swatchMap = {};
    var mapEl = document.getElementById('cart-swatch-map');
    if (mapEl) {
      try { swatchMap = JSON.parse(mapEl.textContent); } catch (e) { swatchMap = {}; }
    }
    var productMapEl = document.getElementById('product-swatch-map');
    if (productMapEl) {
      try {
        var productMap = JSON.parse(productMapEl.textContent);
        Object.keys(productMap).forEach(function (key) { swatchMap[key] = productMap[key]; });
      } catch (e) {}
    }

    function renderCartItemMedia(item) {
      var swatch = swatchMap[String(item.variant_id)];
      if (swatch) {
        var media = '';
        if (swatch.color) {
          media = '<span class="cart-drawer__swatch" style="background-color: ' + swatch.color + '"></span>';
        } else if (swatch.image) {
          media = '<span class="cart-drawer__swatch"><img src="' + swatch.image + '" alt=""></span>';
        } else {
          media = '<span class="cart-drawer__swatch"></span>';
        }
        return '<div class="cart-drawer__line-img cart-drawer__line-img--swatch swatch-' + swatch.handle + '">' + media + '</div>';
      }
      var imgSrc = item.image || (item.featured_image && item.featured_image.url) || '';
      if (imgSrc) {
        imgSrc = imgSrc.replace(/(\.\w+)$/, '_small$1');
      }
      return imgSrc ? '<div class="cart-drawer__line-img"><img src="' + imgSrc + '" alt=""></div>' : '';
    }

    var itemsHTML = '';
    cart.items.forEach(function (item) {
      var productTitle = item.product_title || item.title;
      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      itemsHTML += '<div class="cart-drawer__line-item">' +
        renderCartItemMedia(item) +
        '<div class="cart-drawer__line-info">' +
        '<div class="cart-drawer__line-title">' + productTitle + '</div>' +
        (variantTitle ? '<div class="cart-drawer__line-variant">' + variantTitle + '</div>' : '') +
        '<div class="cart-drawer__line-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-drawer__qty-controls">' +
        '<button class="cart-drawer__qty-btn" data-cart-qty-minus data-line-key="' + item.key + '" aria-label="Decrease quantity">-</button>' +
        '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
        '<button class="cart-drawer__qty-btn" data-cart-qty-plus data-line-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button class="cart-drawer__line-remove" data-remove-key="' + item.key + '">Remove</button>' +
        '</div>' +
        '</div>';
    });

    itemsContainer.innerHTML = itemsHTML;

    footerContainer.innerHTML = '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<a href="/checkout" class="btn btn--dark btn--full">Checkout</a>';

    // Bind remove buttons
    itemsContainer.querySelectorAll('[data-remove-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-remove-key');
        changeCartQty(key, 0);
      });
    });

    // Bind quantity minus buttons
    itemsContainer.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-line-key');
        var currentQty = parseInt(this.nextElementSibling.textContent);
        var newQty = currentQty > 1 ? currentQty - 1 : 0;
        changeCartQty(key, newQty);
      });
    });

    // Bind quantity plus buttons
    itemsContainer.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-line-key');
        var currentQty = parseInt(this.previousElementSibling.textContent);
        changeCartQty(key, currentQty + 1);
      });
    });
  }

  function changeCartQty(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      });
  }

  /* ========== ADD TO CART ========== */
  function isMaintenanceModalOpen() {
    var modal = document.getElementById('maintenance-modal');
    return !!modal && modal.classList.contains('is-open');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        btn.classList.add('added');
        updateCartCount();
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 1500);
        if (!isMaintenanceModalOpen()) {
          openCartDrawer();
        }
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  /* ========== PRODUCT PAGE FORM ========== */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (submitBtn) {
          submitBtn.textContent = 'Added!';
          setTimeout(function () {
            submitBtn.textContent = 'Add to Cart';
            submitBtn.disabled = false;
          }, 1500);
        }
        updateCartCount();
        if (!isMaintenanceModalOpen()) {
          openCartDrawer();
        }
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.textContent = 'Add to Cart';
          submitBtn.disabled = false;
        }
      });
  });

  /* ========== CART COUNT ========== */
  function updateCartCount(count) {
    if (typeof count !== 'undefined') {
      setCartCount(count);
    } else {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCartCount(cart.item_count); });
    }
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ========== FORMAT MONEY ========== */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + amount;
  }

  /* ========== SCROLL ANIMATIONS ========== */
  var revealElements = document.querySelectorAll('.reveal');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealElements.forEach(function (el) { observer.observe(el); });
  }

  /* ========== PARALLAX HERO ========== */
  var heroImg = document.querySelector('.hero__bg img');
  if (heroImg) {
    window.addEventListener('scroll', function () {
      var scrollY = window.pageYOffset;
      if (scrollY < window.innerHeight) {
        heroImg.style.transform = 'translateY(' + (scrollY * 0.35) + 'px) scale(1.05)';
      }
    }, { passive: true });
  }

  /* ========== HEADER SCROLL ========== */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* ========== PRODUCT PAGE: VARIANT SELECT ========== */
  var variantSelect = document.querySelector('.product-page__variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var hiddenId = document.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = this.value;
    });
  }

  /* ========== PRODUCT PAGE: QUANTITY ========== */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentNode.querySelector('.product-page__qty-input');
      if (input && parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentNode.querySelector('.product-page__qty-input');
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  /* ========== CART PAGE: QUANTITY ========== */
  document.querySelectorAll('.cart-page .cart-page__qty-btn[data-cart-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentNode.querySelector('.cart-page__qty-input');
      if (input && parseInt(input.value) > 0) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });
  document.querySelectorAll('.cart-page .cart-page__qty-btn[data-cart-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentNode.querySelector('.cart-page__qty-input');
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

})();
